(function () {
  'use strict';

  // Sticky/transparent header on home
  var header = document.getElementById('siteHeader');
  if (header && document.body.classList.contains('template-index')) {
    var onScroll = function () {
      if (window.scrollY > 60) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile navigation
  var nav = document.getElementById('mobileNav');
  var openBtn = document.getElementById('navToggle');
  var closeBtn = nav ? nav.querySelector('.mobile-nav__close') : null;
  if (openBtn && nav) openBtn.addEventListener('click', function () { nav.classList.add('is-open'); });
  if (closeBtn && nav) closeBtn.addEventListener('click', function () { nav.classList.remove('is-open'); });

  // Search overlay
  var overlay = document.getElementById('searchOverlay');
  var searchOpen = document.querySelector('.search-open');
  var searchClose = overlay ? overlay.querySelector('.search-overlay__close') : null;
  if (searchOpen && overlay) {
    searchOpen.addEventListener('click', function () {
      overlay.classList.add('is-open');
      var input = overlay.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 60);
    });
  }
  if (searchClose && overlay) searchClose.addEventListener('click', function () { overlay.classList.remove('is-open'); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay) overlay.classList.remove('is-open');
    if (e.key === 'Escape' && nav) nav.classList.remove('is-open');
  });

  // Product gallery thumbnails
  var mainImage = document.getElementById('mainImage');
  document.querySelectorAll('.thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-src');
      if (mainImage && src) mainImage.src = src;
      document.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // Quantity selector
  document.querySelectorAll('.qty-selector').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('.qty-minus');
    var plus = wrap.querySelector('.qty-plus');
    var clamp = function (v) { v = parseInt(v, 10) || 1; return Math.max(1, v); };
    if (minus) minus.addEventListener('click', function () { input.value = clamp(parseInt(input.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = clamp(parseInt(input.value, 10) + 1); });
  });

  // Add to cart via AJAX, then go to cart
  var form = document.getElementById('productForm');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.btn-add');
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout...'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status) throw new Error(data.description || 'Erreur');
          window.location.href = '/cart';
        })
        .catch(function (err) {
          alert(err.message || "Impossible d'ajouter au panier.");
          if (btn) { btn.disabled = false; btn.textContent = 'Ajouter au panier'; }
        });
    });
  }
})();

// 17TRACK redirect
(function(){
  var tf=document.getElementById('trackingForm');
  if(tf){
    tf.addEventListener('submit',function(e){
      e.preventDefault();
      var n=document.getElementById('trackingNumber');
      var v=n?n.value.trim():'';
      if(v) window.open('https://t.17track.net/fr#nums='+encodeURIComponent(v),'_blank');
    });
  }
})();


// Fallback cookie banner: only when Shopify native banner is not present
(function(){
  var el=document.getElementById('clCookieBanner');
  if(!el) return;
  var KEY='cachelune_cookie_choice';
  var nativeSeen=false;
  function check(){
    var native=document.getElementById('shopify-pc__banner');
    if(native){ nativeSeen=true; if(!el.hidden) el.hidden=true; return; }
    if(!nativeSeen && !localStorage.getItem(KEY)) el.hidden=false;
  }
  setTimeout(check,1200);
  setTimeout(check,2600);
  setInterval(check,1800);
  el.addEventListener('click',function(e){
    var b=e.target.closest('[data-cookie-choice]');
    if(!b) return;
    localStorage.setItem(KEY,b.getAttribute('data-cookie-choice'));
    el.hidden=true;
  });
})();
